import { render, staticRenderFns } from "./server-side-referrers-select.vue?vue&type=template&id=6fc8abd8"
import script from "./server-side-referrers-select.vue?vue&type=script&lang=ts"
export * from "./server-side-referrers-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports